import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOnaPlusCircle: FC<BaseIconProps> = ({ size = "sm", className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    {...props}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.33337 8.00001C1.33337 4.31811 4.31814 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001ZM8.50004 4.67189H7.50004V7.50031H4.67161L4.67161 8.50031H7.50004V11.3287H8.50004V8.50031H11.3285V7.50031H8.50004V4.67189Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    {...props}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.66671 10.0001C1.66671 5.39771 5.39768 1.66675 10.0001 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6024 14.6024 18.3334 10.0001 18.3334C5.39768 18.3334 1.66671 14.6024 1.66671 10.0001ZM10.6251 5.83993H9.37506V9.37546H5.83953L5.83953 10.6255H9.37506V14.1609H10.6251V10.6255H14.1606V9.37546H10.6251V5.83993Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    {...props}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.00005 12C2.00005 6.47715 6.47721 2 12.0001 2C17.5229 2 22.0001 6.47715 22.0001 12C22.0001 17.5228 17.5229 22 12.0001 22C6.47721 22 2.00005 17.5228 2.00005 12ZM12.7501 7.00791H11.2501V11.2505H7.00743L7.00743 12.7505H11.2501V16.9931H12.7501V12.7505H16.9928V11.2505H12.7501V7.00791Z"
                        fill="currentColor"
                    />
                </svg>
            );
    }
};
